import { put, call, takeEvery } from 'redux-saga/effects';
import { replace, push } from 'connected-react-router';
import {
  FEEDVIEWS_REQUEST,
  FEEDVIEW_REQUEST,
  CREATE_FEEDVIEW_REQUEST,
  MODIFY_FEEDVIEW_REQUEST,
  DELETE_FEEDVIEW_REQUEST,
} from './actionTypes';
import {
  feedviewsSuccess,
  feedviewsFailure,
  feedviewSuccess,
  feedviewFailure,
  createFeedviewSuccess,
  createFeedviewFailure,
  modifyFeedviewSuccess,
  modifyFeedviewFailure,
  deleteFeedviewSuccess,
  deleteFeedviewFailure,
} from './actions';
import FeedviewService from '../../services/FeedviewsService';

export function* getFeedviewsTask() {
  try {
    const list = yield call(FeedviewService.getFeedviews);
    const formattedList = list.map(fv => {
      fv.label = fv.name ? fv.name : fv.id;
      return fv;
    });
    yield put(feedviewsSuccess(formattedList));
  } catch (error) {
    yield put(feedviewsFailure(error));
  }
}

export function* getFeedviewTask(action) {
  try {
    const { feedviewId, editFeedview } = action.payload;
    const feedview = yield call(FeedviewService.getFeedview, feedviewId);
    if (editFeedview) {
      yield put(push(`/feedviews/${feedview.id}`));
    }
    yield put(feedviewSuccess(feedview));
  } catch (error) {
    yield put(feedviewFailure(error));
  }
}

export function* createFeedviewTask(action) {
  try {
    const params = action.payload;
    const feedview = yield call(FeedviewService.createFeedview, params);
    yield put(createFeedviewSuccess(feedview));
    yield put(replace(`/feedview/${feedview.id}/filters`));
  } catch (error) {
    yield put(createFeedviewFailure(error));
  }
}

export function* updateFeedviewTask(action) {
  try {
    const { feedview } = action.payload;
    const updatedFeedview = yield call(
      FeedviewService.updateFeedview,
      feedview,
    );
    yield put(modifyFeedviewSuccess(updatedFeedview));
  } catch (error) {
    yield put(modifyFeedviewFailure(error));
  }
}

export function* deleteFeedviewTask(action) {
  try {
    const feedviewId = action.payload;
    yield call(FeedviewService.deleteFeedview, feedviewId);
    yield put(deleteFeedviewSuccess(feedviewId));
  } catch (error) {
    yield put(deleteFeedviewFailure(error));
  }
}

export function* feedviewsSaga() {
  yield takeEvery(FEEDVIEWS_REQUEST, getFeedviewsTask);
  yield takeEvery(FEEDVIEW_REQUEST, getFeedviewTask);
  yield takeEvery(CREATE_FEEDVIEW_REQUEST, createFeedviewTask);
  yield takeEvery(MODIFY_FEEDVIEW_REQUEST, updateFeedviewTask);
  yield takeEvery(DELETE_FEEDVIEW_REQUEST, deleteFeedviewTask);
}
